import { Outlet, Link, useLocation } from 'react-router-dom'
import type { User } from '../lib/types'
import AICompanion from './AICompanion'

interface Props {
  user: User | null
  onLogout: () => void
}

export default function Layout({ user, onLogout }: Props) {
  const { pathname } = useLocation()
  const nav = [
    { to: '/', label: 'Home' },
    { to: '/companies', label: 'Exhibitors' },
    { to: '/industry-map', label: 'Industry Map' },
    { to: '/floor', label: 'Floor' },
    { to: '/tracks', label: 'Tracks' },
  ]

  return (
    <div className="min-h-screen flex flex-col">
      <header className="glass-dark text-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-bold text-lg">
            <span className="text-2xl">🤖</span>
            <span className="hidden sm:inline">Automates 2026</span>
            <span className="sm:hidden">A26</span>
          </Link>

          <nav className="flex items-center gap-1">
            {nav.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                  pathname === to ? 'bg-white/20' : 'hover:bg-white/10'
                }`}
              >
                {label}
              </Link>
            ))}
            {user ? (
              <div className="flex items-center gap-2 ml-2">
                {user.role === 'admin' && (
                  <Link to="/admin" className={`px-3 py-1.5 rounded-lg text-sm font-medium ${pathname === '/admin' ? 'bg-white/20' : 'hover:bg-white/10'}`}>
                    Admin
                  </Link>
                )}
                <Link to="/profile" className="px-3 py-1.5 rounded-lg text-sm hover:bg-white/10">
                  {user.name || user.email.split('@')[0]}
                </Link>
                <button onClick={onLogout} className="px-2 py-1.5 text-sm opacity-70 hover:opacity-100">
                  Logout
                </button>
              </div>
            ) : (
              <Link to="/login" className="ml-2 px-3 py-1.5 bg-white text-brand-800 rounded-lg text-sm font-medium hover:bg-gray-100">
                Sign In
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="bg-gray-100 border-t py-4 text-center text-sm text-gray-500">
        Automates 2026 Conference Companion &middot; McCormick Place, Chicago
      </footer>

      {user && <AICompanion />}
    </div>
  )
}
